import { NwButton } from "@nawy/ui";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { Box, Stack } from "@mui/material";

interface ModalFooterProps {
  cancelButtonText?: string;
  confirmButtonText?: string;
  extraButtonText?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  onExtra?: () => void;
  isLoading?: boolean;
  isConfirmDisabled?: boolean;
  isExtraDisabled?: boolean;
}

const ModalFooter = ({
  cancelButtonText,
  confirmButtonText,
  extraButtonText,
  onCancel,
  onConfirm,
  onExtra,
  isLoading = false,
  isConfirmDisabled = false,
  isExtraDisabled = false,
}: ModalFooterProps) => {
  const hasCancelButton = cancelButtonText && onCancel;
  const hasConfirmButton = confirmButtonText && onConfirm;
  const hasExtraButton = extraButtonText && onExtra;

  return (
    <Stack
      direction="row"
      padding={`${nawyTheme.nawy.spacing.sm} ${nawyTheme.nawy.spacing.md}`}
      alignItems="center"
      justifyContent={
        hasCancelButton && hasConfirmButton ? "space-between" : "flex-end"
      }
      gap={nawyTheme.nawy.spacing.xs}
      alignSelf="stretch"
      borderTop={`1px solid ${nawyTheme.nawy.colors.semantic.border.secondary}`}
      bgcolor={nawyTheme.nawy.colors.semantic.layer.primary}
    >
      {hasCancelButton && (
        <NwButton
          variant="outlined"
          onClick={onCancel}
          disabled={isLoading}
          sx={{ width: "fit-content" }}
        >
          {cancelButtonText}
        </NwButton>
      )}

      <Box sx={{ display: "flex", gap: 1 }}>
        {hasExtraButton && (
          <NwButton
            variant="outlined"
            onClick={onExtra}
            disabled={isExtraDisabled || isLoading}
            sx={{ width: "fit-content" }}
          >
            {extraButtonText}
          </NwButton>
        )}

        {hasConfirmButton && (
          <NwButton
            onClick={onConfirm}
            disabled={isConfirmDisabled}
            loading={isLoading}
            sx={{ width: "fit-content" }}
          >
            {confirmButtonText}
          </NwButton>
        )}
      </Box>
    </Stack>
  );
};

export default ModalFooter;
